import { IDemo, SessionIds } from 'types'
import track from 'assets/captions/video-security-and-analytics.en.vtt'
import { getSharedAsset } from '../utils'

const video = getSharedAsset('video-security-and-analytics.mp4', 'sessions', 'videos')
const poster = getSharedAsset('video-security-and-analytics.png', 'sessions', 'posters')
const monolith = getSharedAsset('video-security-and-analytics.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('connected-health.png', 'sessions', 'thumbnails')

export const videoSecurity: IDemo = {
  id: SessionIds.videoSecurity,
  video,
  monolith,
  poster,
  tracks: [
    {
      kind: 'captions',
      src: track,
      srcLang: 'en',
      label: 'EN',
      default: false
    }
  ],
  end: {
    header: 'Video Security & Analytics',
    body: `Timely information is critical for First Responders. See how high throughput 5G networks, Mobile Edge Computing (MEC) and cloud technologies can help provide quick access to information. `,
    nextDemoText: 'Connected Health',
    nextDemoId: SessionIds.connectedHealth,
    nextDemoThumbnail,
    previousDemoId: SessionIds.managedVenues
  }
}
